import { z } from 'zod';
import { factSchema, stopKindSchema } from './artifact-parts.js';
/**
 * The panels a set of loads turns into (core/domain/artifact-loads.ts). Every
 * string is the provider's own text; the web escapes it.
 */
/** One load as the board and the calendar name it. */
const loadRefSchema = z.object({
    reference: z.string(),
    customer: z.string().optional(),
    pickup: z.string().optional(),
    delivery: z.string().optional(),
    pickupDay: z.string().optional(),
    deliveryDay: z.string().optional(),
});
export const moneyArtifactSchema = z.object({
    kind: z.literal('money'),
    /** Present only when a documented provider field carried one. */
    currency: z.string().optional(),
    lines: z.array(z.object({
        reference: z.string(),
        customer: z.string().optional(),
        status: z.string().optional(),
        haulingRate: z.number().optional(),
        accessorials: z.number().optional(),
        total: z.number().optional(),
        remitTo: z.string().optional(),
        facts: z.array(factSchema),
    })),
    total: z.number().optional(),
    truncated: z.boolean(),
});
export const boardArtifactSchema = z.object({
    kind: z.literal('board'),
    columns: z.array(z.object({
        status: z.string(),
        count: z.number().int(),
        loads: z.array(loadRefSchema),
    })),
    truncated: z.boolean(),
});
export const customersArtifactSchema = z.object({
    kind: z.literal('customers'),
    rows: z.array(z.object({
        customer: z.string(),
        loads: z.number().int(),
        statuses: z.array(z.object({ status: z.string(), count: z.number().int() })),
        totalRate: z.number().optional(),
    })),
    truncated: z.boolean(),
});
export const calendarArtifactSchema = z.object({
    kind: z.literal('calendar'),
    days: z.array(z.object({
        day: z.string(),
        entries: z.array(z.object({
            kind: stopKindSchema,
            reference: z.string(),
            place: z.string().optional(),
            at: z.string().optional(),
        })),
    })),
    from: z.string(),
    to: z.string(),
});
export const rankingArtifactSchema = z.object({
    kind: z.literal('ranking'),
    dimension: z.enum(['customer', 'truck']),
    rows: z.array(z.object({ label: z.string(), count: z.number().int() })),
    truncated: z.boolean(),
});
export const kpiArtifactSchema = z.object({
    kind: z.literal('kpi'),
    items: z.array(z.object({ label: z.string(), value: z.number() })),
});
//# sourceMappingURL=artifacts-loads.js.map